var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.graphic},[_c('v-progress-circular',{attrs:{"rotate":_vm.rotate,"size":_vm.size,"value":_vm.value,"width":_vm.width,"color":_vm.color}},[_c('span',{class:_vm.$style.text},[_vm._v(" "+_vm._s(this.$props.currentStep)+" de "+_vm._s(this.$props.stepsQuantity)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }